import {
  Home as HomeIcon,
  Email as EmailIcon,
  Settings as SettingsIcon,
  BarChart as BarChartIcon,
  People as PeopleIcon,
  Link as LinkIcon,
  Sms as SmsIcon,
  FileCopy as FileCopyIcon,
  Sms,
} from "@mui/icons-material";
import GridOnIcon from "@mui/icons-material/GridOn";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import CallMissedIcon from "@mui/icons-material/CallMissed";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import SchemaIcon from "@mui/icons-material/Schema";
import ContactsIcon from "@mui/icons-material/Contacts";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import HttpIcon from '@mui/icons-material/Http';

const serviceConfig = {
  SMS: {
    title: "SMS",
    icon: <Sms sx={{ color: "#60a5fa" }} />, // blue
    submenu: [
      { title: "Principal Entity", path: "/principalentity", icon: "" },
      { title: "Template", path: "/template", icon: "" },
      { title: "Header", path: "/create-header", icon: "" },
    ],
  },
  RCS: {
    title: "RCS",
    icon: <SpeakerNotesIcon sx={{ color: "#c4b5fd" }} />, // violet
    submenu: [
      { title: "Template", path: "/rcs-template-list", icon: "" },
      { title: "RCS Bot", path: "/rcs-bot-list", icon: "" },
    ],
  },
  EMAIL: {
    title: "EMAIL",
    icon: <EmailIcon sx={{ color: "#f9a8d4" }} />,
    submenu: [{ title: "Email Template", path: "/email-template", icon: "" }],
  },
  WhatsApp: {
    title: "Whatsapp",
    icon: <WhatsAppIcon sx={{ color: "#86efac" }} />,
    submenu: [
      { title: "Template ", path: "/whatsapp-list", icon: "" },
      { title: "Live Chat ", path: "/whatsapp-live-chat", icon: "" },
      { title: "Live Agent ", path: "/create-agent", icon: "" },
      { title: "Chat Bot Flow ", path: "/flow-designer", icon: "" },
      { title: "Ai Template", path: "/llm-template",icon:""},
      { title: "WABA Number Quality", path: "/whatsapp-number-quality", icon: "" },
    ],
  },
  Truecaller: {
    title: "Truecaller",
    icon: <PermPhoneMsgIcon sx={{ color: "#93c5fd" }} />,
    submenu: [
      {
        title: "Template",
        path: "/truecaller-template",
        icon: "",
      },
    ],
  },
  Email: {
    title: "Email",
    icon: <EmailIcon sx={{ color: "#f9a8d4" }} />, // pink
    submenu: [{ title: "Email Template", path: "/email-template", icon: "" }],
  },
};

export const getSidebar = (
  services = [],
  isDataEnabled = false,
  canShowTransaction = false,
  customerId = null,
  canShowWorkflow = false,
  isReseller = false,
) => {
  const manageServiceSubmenu = [];

  if (services.length > 0) {
    services.forEach((service) => {
      const serviceName = service.service_name;
      const config = serviceConfig[serviceName];
      if (config) {
        manageServiceSubmenu.push({
          title: config.title,
          icon: config.icon,
          path: "",
          submenu: config.submenu,
        });
      }
    });
  } else {
    manageServiceSubmenu.push(
      serviceConfig.SMS,
      serviceConfig.RCS,
      serviceConfig.WhatsApp,
      serviceConfig.Truecaller,
      serviceConfig.Email,
    );
  }

  const manageDbSection = isDataEnabled
    ? {
        title: "Manage DB",
        icon: <StorageIcon sx={{ color: "#f9a8d4" }} />, // pink
        path: "",
        submenu: [
          { title: "Create Fields", path: "/create-db", icon: "" },
          { title: "Upload Data", path: "/upload-data", icon: "" },
          { title: "View DB", path: "/view-dbdata", icon: "" },
        ],
      }
    : null;

  return [
    {
      title: "Dashboard",
      icon: <HomeIcon sx={{ color: "#86efac" }} />, // green
      path: "/",
      submenu: [],
    },
    {
      title: "Create Campaigns",
      icon: <SmsIcon sx={{ color: "#60a5fa" }} />, // blue
      path: "/sms-panel",
      submenu: [],
    },
    // {
    //   title: "Unified SMS",
    //   icon: <Sms sx={{ color: "#818cf8" }} />,
    //   path: "/unified-sms",
    //   submenu: [],
    // },
    {
      title: "Create Event",
      icon: <EventAvailableIcon sx={{ color: "#f472b6" }} />, // pink
      path: "/event-creation",
      submenu: [],
    },
    ...(canShowWorkflow
      ? [
          {
            title: "Work Flow",
            icon: <SchemaIcon sx={{ color: "#c4b5fd" }} />,
            path: "",
            submenu: [{ title: "Campaign Flow", path: "/workflow", icon: "" }],
          },
        ]
      : []),
    {
      title: "Clicker",
      icon: <FileCopyIcon sx={{ color: "#fcd34d" }} />, // amber
      path: "",
      submenu: [
        { title: "Manage Campaign", path: "/ManageCampaign", icon: "" },
      ],
    },
    {
      title: "Reports",
      icon: <BarChartIcon sx={{ color: "#fdba74" }} />, // orange
      path: "",
      submenu: [
        { title: "Delivery Report", path: "/deliveryreport", icon: "" },
        { title: "Email report", path: "/email-campaign-report", icon: "" },
        { title: "Scheduled SMS", path: "/scheduledsms", icon: "" },
        { title: "API Report", path: "/apireport", icon: "" },
        // { title: "Consolidate Report", path: "/consolidatereport", icon: "" },
        { title: "MIS Report", path: "/misreport", icon: "" },
        ...(canShowWorkflow
          ? [{ title: "Flow Report", path: "/flow-report", icon: "" }]
          : []),
        ...(canShowTransaction
          ? [{ title: "Credit History", path: "/credithistory", icon: "" }]
          : []),
        {
          title: "Consolidate Report Count",
          path: "/consolidatereportcount",
          icon: "",
      },
        { title: "Download Center", path: "/download-center", icon: "" },
      ],
    },
    {
      title: "Manage Service",
      icon: <SettingsIcon sx={{ color: "#67e8f9" }} />, // cyan
      path: "",
      submenu: manageServiceSubmenu,
    },

    ...(manageDbSection ? [manageDbSection] : []),

    {
      title: "Missed Call",
      icon: <CallMissedIcon sx={{ color: "#fda4af" }} />, // rose
      path: "",
      submenu: [
        {
          title: "Manage",
          path: "/missedcall",
          icon: <CallMissedIcon sx={{ color: "#fda4af" }} />,
        },
        {
          title: "Call Report",
          path: "/callreport",
          icon: <CallReceivedIcon sx={{ color: "#fda4af" }} />,
        },
      ],
    },
    {
      title: "Short Code",
      icon: <CodeIcon sx={{ color: "#6ee7b7" }} />, // emerald
      path: "",
      submenu: [
        {
          title: "Manage Keyword",
          path: "/keyword",
          icon: <CodeIcon sx={{ color: "#6ee7b7" }} />,
        },
        {
          title: "Keyword Report",
          path: "/keywordreport",
          icon: <CallReceivedIcon sx={{ color: "#6ee7b7" }} />,
        },
      ],
    },
    {
      title: "Management",
      icon: <SettingsIcon sx={{ color: "#a5b4fc" }} />, // indigo
      path: "",
      submenu: [
        { title: "Blacklist", path: "/blacklist", icon: "" },
        // { title: "Principal Entity", path: "/principalentity", icon: "" },
        //  { title: "Manage KYC", path: "/managekyc", icon: "" },
        { title: "Manage Category", path: "/category", icon: "" },
        { title: "Short Link", path: "/shortlink", icon: "" },
        { title: "Unicode Finder", path: "/unicodefinder", icon: "" },
        { title: "Manage MPIN", path: "/managempin", icon: "" },
        { title: "Genrate Api Key", path: "/apikey", icon: "" },
        { title: "DLR/URL", path:"dlr-url", icon: ""},
        { title: "Apidocs download",path:"/api-docs-download",icon:""},
      ],
    },

    ...(customerId !== 44
      ? [
          {
            title: "Reseller",
            icon: <PeopleIcon sx={{ color: "#f9a8d4" }} />, // pink
            path: "",
            submenu: [
              { title: "Manage Customer", path: "/managecustomer", icon: "" },
              {
                title: "Transaction History",
                path: "/transactionhistory",
                icon: "",
              },
              {
                title: "Customer Delivery Report",
                path: "/customersmsreport",
                icon: "",
              },
              ...(isReseller
                ? [
                    {
                      title: "Reseller API Report",
                      path: "/resseller-api-report",
                      icon: "",
                    },
                    {
                      title: "Reseller Scheduled SMS",
                      path: "/reseller-scheduledsms",
                      icon: "",
                    },
                    {
                      title: "Reseller MIS Report",
                      path: "/reseller-misreport",
                      icon: "",
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
  ];
};

// Default export (static version for backward compatibility)
const defaultSidebar = getSidebar([]);
export default defaultSidebar;
